<template>
  <div>
    <h1 class="text-2xl font-bold mb-1">
      {{ product.label }}
    </h1>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      required: true,
      type: Object
    }
  }
}
</script>
